import React from 'react';

import CustomSpinner, { CustomSpinnerColor } from '@components/Spinner/CustomSpinner';
import { useOrganizationDetails } from '@hooks';

import AccountSection from './AccountSection';
import AnalyticsSection from './AnalyticsSection';
import UsersSection from './UsersSection';

const Organization = () => {
  const { data, isLoading } = useOrganizationDetails();

  if (isLoading) {
    return (
      <CustomSpinner
        size={15}
        color={CustomSpinnerColor.PrimaryMagenta}
        style={{ display: 'flex', justifyContent: 'center', marginTop: '56px' }}
      />
    );
  }
  const { admins, canViewAnalytics, ...rest } = data;

  return (
    <>
      <AccountSection {...rest} />
      <UsersSection
        admins={admins}
        availableStandardSeats={rest.availableStandardSeats}
        availableProSeats={rest.availableProSeats}
      />
      <AnalyticsSection canViewAnalytics={canViewAnalytics} />
    </>
  );
};

export default Organization;
